import { useSelector } from 'react-redux'

/* Selectors */
import {
  selectWidgetsInDashboard,
  selectWidgetQueryParams
} from 'redux/selectors/DashboardWidgets'

/* Types */
import { ApplicationState } from 'redux/Stores/types'
import { TDashboardWidget } from 'types/GlobalWidget'

/**
 * Get all widgets in a dashboard.
 * @param dashboardId - Dashboard ID
 * @returns Array of widgets belonging to the dashboard
 * (empty array if no dashboard ID)
 */
export const useWidgetsInDashboard = (
  dashboardId: string | null
): TDashboardWidget[] => {
  return useSelector((state: ApplicationState) =>
    selectWidgetsInDashboard(state, dashboardId)
  )
}

export const useWidgetQueryParams = (widgetId: string) => {
  return useSelector((state: ApplicationState) =>
    selectWidgetQueryParams(state, widgetId)
  )
}
